import {
    BEGIN_LOAD_REPORTS_FOR_USER,
    END_LOAD_REPORTS_FOR_USER_SUCCESS,
    END_LOAD_REPORTS_FOR_USER_ERROR,
    BEGIN_LOAD_EMBED_INFO,
    END_LOAD_EMBED_INFO_SUCCESS,
    END_LOAD_EMBED_INFO_ERROR,
    CLEAR_EMBED_INFO,
    EmbedInfo, EmbedPbiInfo, ReportForUser, ReportsForUser, EmbedInfoActionTypes
} from "./types";


const initialEmbedPbiInfoState: EmbedPbiInfo = {
    type: "report",
    embedReport: [],
    embedToken: {
        token: null,
        tokenId: null,
        expiration: null
    }
};

const initialState: EmbedInfo = {
    isLoading: undefined,
    error: null,
    embedPbiInfo: initialEmbedPbiInfoState
};

export default (state: EmbedInfo = initialState, action: EmbedInfoActionTypes): EmbedInfo => {
    switch (action.type) {
        case BEGIN_LOAD_EMBED_INFO:
            return { ...state, isLoading: true };

        case END_LOAD_EMBED_INFO_SUCCESS:
            return { ...state, isLoading: false, embedPbiInfo: action.embedPbiInfo };

        case END_LOAD_EMBED_INFO_ERROR:
            return { ...state, isLoading: false, error: action.error };

        case CLEAR_EMBED_INFO:
            return { ...initialState };

        default:
            return state;
    }
};

const initialReportsForUsersState: ReportsForUser = {
    isLoading : false,
    userReports: [],
    error: null
}

export const pbiReportsForUsers = (state: ReportsForUser = initialReportsForUsersState, action: EmbedInfoActionTypes): ReportsForUser => {
    switch (action.type) {
        case BEGIN_LOAD_REPORTS_FOR_USER:
            return { ...state, isLoading: true };
        case END_LOAD_REPORTS_FOR_USER_SUCCESS:
            return { ...state, isLoading: false, userReports: action.userReports};
        case END_LOAD_REPORTS_FOR_USER_ERROR:
            return { ...state, isLoading:false, error: action.error };
        default:
            return { ...state };
    }
};